import { Controller } from "@hotwired/stimulus"

// Intercepts clicks on attachment tile links so the drawer opens instead of
// navigating. Turbo 8 auto-prefetches the link href on hover, so by the time
// the user clicks the lazy turbo-frame inside the drawer already has a cached
// response ready to render instantly.
export default class extends Controller {
  openDrawer(event) {
    event.preventDefault()
    const drawer = document.getElementById(event.currentTarget.dataset.drawerId)
    if (drawer) drawer.showPopover()
  }
}
